// extracted by mini-css-extract-plugin
module.exports = {"emptyCartContainer":"empty-cart_emptyCartContainer__J8OPN","headingBlock":"empty-cart_headingBlock__89w__"};